<div class="container-fluid">
    <div class="logo text-center mt-4 py-4">
        <a routerLink="/auth/login">
            <img src="assets/images/logo.png" width="200">
        </a>
    </div>
    <div class="contents mb-5">
        <router-outlet></router-outlet>
    </div>
    <div class="text-center small mb-3 text-muted">
        <a href="#" class="text-muted mr-3">Terms of use</a>
        <a href="#" class="text-muted mr-3">Privacy policy</a>
        <a href="#" class="text-muted mr-3">Support</a>
        <a href="#" class="text-muted mr-3">Contact</a>
        <br />
        © 2024 InsurEco Inc, All rights reserved.
    </div>
</div>